import i18n from '@/langs/i18n.js';

export default {
  day1: {
    full: i18n.t('daysOfWeek.monday'),
    short: i18n.t('daysOfWeek.mondayShort')
  },
  day2: {
    full: i18n.t('daysOfWeek.tuesday'),
    short: i18n.t('daysOfWeek.tuesdayShort')
  },
  day3: {
    full: i18n.t('daysOfWeek.wednesday'),
    short: i18n.t('daysOfWeek.wednesdayShort')
  },
  day4: {
    full: i18n.t('daysOfWeek.thursday'),
    short: i18n.t('daysOfWeek.thursdayShort')
  },
  day5: {
    full: i18n.t('daysOfWeek.friday'),
    short: i18n.t('daysOfWeek.fridayShort')
  },
  day6: {
    full: i18n.t('daysOfWeek.saturday'),
    short: i18n.t('daysOfWeek.saturdayShort')
  },
  day7: {
    full: i18n.t('daysOfWeek.sunday'),
    short: i18n.t('daysOfWeek.sundayShort')
  }
};
